/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout wrap>
      <v-container fluid grid-list-md pa-1>
        <components v-if="this.isComponent('scb-dash')"></components>
        <components v-else-if="this.isComponent('scb-channel')"></components>
        <components v-else-if="this.isComponent('zone-monitoring')"></components>
        <no-device v-else :message="subscriptionMessage"></no-device>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters} from 'vuex'
const components = () => import('@/components/String-monitoring/String')
const NoDevice = () => import('@/components/utility/NoDevice.vue')

export default {

  components: {
    components,
    NoDevice
  },
  data() {
    return {
      interval: null,
      subscriptionMessage:
        'This feature is not applicable for your plant.'
    }
  },
  destroyed() {
    clearInterval(this.interval)
  },
  computed: {
    ...mapGetters(['isComponent'])
  }

}
</script>

<style scoped>
/* #overview_container {
  overflow: hidden;
} */
</style>
